import { createFeatureSelector } from '@ngrx/store';

import type { RetentionState } from './retention-state.interface';

export const retentionSelectorKey = 'retention';

export const getRetentionState =
  createFeatureSelector<RetentionState>(retentionSelectorKey);
